import { getEnv } from '@src/apis/shared';
import { requireAuth } from '@src/providers/dataProvider/shared';
import {
  ConfigsApi,
  Configuration,
} from '@troverecommerce/ps-configs-api-client';

export const getConfigsApiClient = () => {
  const token = requireAuth();

  const config = new Configuration({
    basePath: getEnv('CONFIG_API_BASE'),
    apiKey: token,
  });

  return new ConfigsApi(config);
};